import React, { createContext, useContext, useReducer } from "react";

const DuePaymentsContext = createContext();

export const useDuePayments = () => useContext(DuePaymentsContext);

const initialState = {
  modalOpen: false,
  bellCount: 0,
  lastFetched: null,
};

const duePaymentsReducer = (state, action) => {
  switch (action.type) {
    case "OPEN_MODAL":
      return { ...state, modalOpen: true };
    case "CLOSE_MODAL":
      return { ...state, modalOpen: false };
    case "TOGGLE_MODAL":
      return { ...state, modalOpen: !state.modalOpen };
    case "UPDATE_BELL_COUNT":
      return { ...state, bellCount: action.payload };
    case "SET_LAST_FETCHED":
      return { ...state, lastFetched: action.payload };
    default:
      return state;
  }
};

export const DuePaymentsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(duePaymentsReducer, initialState);

  return (
    <DuePaymentsContext.Provider value={{ state, dispatch }}>
      {children}
    </DuePaymentsContext.Provider>
  );
};
